import { createAction } from "@reduxjs/toolkit";
import type { FileMetadata } from "@somewear/api";
import type {
	DownloadFileRequestPayload,
	DownloadFileResponse,
	GetWorkspaceFilesRequestPayload,
	GetWorkspaceFilesResponse,
	UploadFileRequest,
	UploadFileResponse,
} from "@somewear/model";
import { createActionSet } from "@somewear/model";

export const emitFileReceivedFromStream = createAction<FileMetadata.AsObject>(
	"messaging/fileFromStream",
);

export const fileActions = {
	uploadFile: createActionSet<UploadFileRequest, UploadFileResponse>("messages/uploadFile"),
	downloadFile: createActionSet<DownloadFileRequestPayload, DownloadFileResponse>(
		"messages/downloadFile",
	),
	getFiles: createActionSet<GetWorkspaceFilesRequestPayload, GetWorkspaceFilesResponse>(
		"messages/getFiles",
	),
};
